import { useQuery } from "@apollo/client";
import { useMemo } from "react";
import { GET_COMPANY_DOCUMENT_FOLDER_TREE } from "../api/get-company-document-folder-tree";
import { foldersToTreeSelectNodes } from "./folders-to-tree-select-nodes";
import { FolderNode } from "./types";
import { valueOrNull } from "@/shared/value";

export function useCompanyDocumentFolders() {
  const { data, loading } = useQuery(GET_COMPANY_DOCUMENT_FOLDER_TREE);

  const folders = useMemo<FolderNode[]>(
    () =>
      (data?.getCompanyDocumentTree ?? [])
        .filter((node) => node.__typename === "CompanyDocumentFolderNodeDto")
        // Скрытую папку выбрать нельзя — её идентификатора у клиента нет.
        .flatMap((node) => {
          const folder = valueOrNull(node.folder);

          return folder
            ? [
                {
                  id: folder.id,
                  parentId: node.parentId,
                  name: folder.name.value,
                  color: folder.color,
                },
              ]
            : [];
        }),
    [data?.getCompanyDocumentTree],
  );

  const treeData = useMemo(() => foldersToTreeSelectNodes(folders), [folders]);

  return { folders, treeData, loading };
}
